import { useQuery } from '@tanstack/react-query';
import { getWeeklySummary } from '../lib/weeklyApi';

/**
 * Load the Weekly Summary (CLE-71 / CLE-74): per-member tasks whose status
 * changed during the selected week (current by default, or `week` such as
 * "2026-W24"), grouped by status, plus a per-day timeline. Cached for 5 minutes
 * to match the Daily Summary's caching policy; past weeks never change so the
 * cache key keeps them stable across navigation.
 */
export function useWeeklySummary(week?: string) {
  return useQuery({
    queryKey: ['weekly-summary', week ?? 'current'],
    queryFn: () => getWeeklySummary(week),
    staleTime: 5 * 60 * 1000,
  });
}
